import React from 'react'
import { useAudio, AUDIO } from '@/app/providers/AudioProvider';

const ToggleFFXIV = ({
    value,
    onChange,
    text,
    shape = 'circle',
    children
}: {
    value: boolean
    onChange: (newValue: boolean) => void
    text?: string
    shape?: 'circle' | 'square'
    children?: React.ReactNode
}) => {
    const { play } = useAudio();
    
    return (
        <div
            onMouseEnter={() => play(AUDIO.HOVER)}
            onClick={() => {
                play(AUDIO.CLICK);
                onChange(!value);
            }}
            className="flex items-center gap-2 cursor-pointer w-fit"
        >
            <div>
                {shape === 'circle' ? (
                    <>
                        {value ? (
                            <div className="z-20 h-2.5 w-2.5 bg-yellow-400 rounded-full shadow-[0_0_2px_2px] shadow-yellow-500/80 border border-yellow-100/90"></div>
                        ) : (
                            <div className="z-20 relative h-2.5 w-2.5 bg-slate-200/20 rounded-full shadow-slate-100/50 shadow-[0_0.5px_2px_0.5px] after:absolute after:bg-slate-100/10 after:rounded-full after:top-0.5 after:left-0.5 after:w-[4px] after:h-[4px] after:shadow-slate-100/10 after:shadow-[0_0_2px_0.5px]"></div>
                        )}
                    </>

                ) : (
                    <>
                        {value ? (
                            <div className="z-20 h-2.5 w-2.5 bg-yellow-400 shadow-[0_0_2px_2px] shadow-yellow-500/80 border border-yellow-100/90"></div>
                        ) : (
                            <div className="z-20 relative h-2.5 w-2.5 bg-slate-200/20 shadow-slate-100/50 shadow-[0_0.5px_2px_0.5px] after:absolute after:bg-slate-100/10 after:top-0.5 after:left-0.5 after:w-[4px] after:h-[4px] after:shadow-slate-100/10 after:shadow-[0_0_2px_0.5px]"></div>
                        )}
                    </>

                )}
            </div>
            {text && (
                <div className="text-[#EEE1C5] text-shadow shadow-black/80 text-lg">{text}</div>
            )}
            {children}
        </div>
    )
}

export default ToggleFFXIV